import { useMediaQueries } from 'hooks';

const useBreakpointName = () => {
  const { isMobile, isTablet, isDesktop, isLargeDesktop, isExtraLargeDesktop } = useMediaQueries();

  if (isMobile) return 'xs';
  if (isTablet) return 'sm';
  if (isDesktop) return 'md';
  if (isLargeDesktop) return 'lg';
  if (isExtraLargeDesktop) return 'xl';

  return null;
};

export default useBreakpointName;
